import React, { useEffect, useState } from 'react'

import { SxProps } from '@mui/material'
import Box from 'components_new/atoms/Box'

interface NumberCounterProps {
  duration?: number // in ms, default 800
  sx?: SxProps
  target: number
}

const NumberCounter = React.forwardRef(
  (props: NumberCounterProps, ref: any) => {
    const { duration = 800, target, sx } = props

    const [count, setCount] = useState(0)

    useEffect(() => {
      let start = 0
      const startTime = performance.now()

      const step = (timestamp: number) => {
        const progress = Math.min((timestamp - startTime) / duration, 1)
        const value = Math.floor(progress * target)

        if (value !== start) {
          setCount(value)
          start = value
        }

        if (progress < 1) {
          requestAnimationFrame(step)
        }
      }

      requestAnimationFrame(step)
    }, [target, duration])

    return (
      <Box
        component="span"
        ref={ref}
        sx={{
          bgcolor: 'action.focus',
          borderRadius: 1,
          pl: '0.15em',
          pr: '0.2em',
          ...sx
        }}
      >
        <Box component="span" sx={{ position: 'relative' }}>
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              justifyContent: 'center',
              left: 0,
              position: 'absolute',
              right: 0
            }}
          >
            {count.toLocaleString()}
          </Box>
          <Box component="span" sx={{ opacity: 0 }}>
            {target}
          </Box>
        </Box>
      </Box>
    )
  }
)

NumberCounter.displayName = 'NumberCounter'
export default NumberCounter
